export const calculateSpacer = (elementRef:any,spacerElementRef:any,includeHeader:boolean) =>{
    let footerElement = document.querySelector('footer');
    let footerHeight = 0;

    if(footerElement)
    {
        footerHeight = parseInt(window.getComputedStyle(footerElement).getPropertyValue('margin-top'));
        footerHeight += parseInt(window.getComputedStyle(footerElement).getPropertyValue('margin-bottom'));
        footerHeight += parseInt(window.getComputedStyle(footerElement).getPropertyValue('height'));
        console.log("footer height",footerHeight);
    }
    
    let headerElement = document.querySelector('header');
    let headerHeight = 0;
    if(headerElement)
    {
        headerHeight = parseInt(window.getComputedStyle(headerElement).getPropertyValue('margin-top'));
        headerHeight += parseInt(window.getComputedStyle(headerElement).getPropertyValue('margin-bottom'));
        headerHeight += parseInt(window.getComputedStyle(headerElement).getPropertyValue('height'));
        console.log("header height",headerHeight);
    }
    let myelementHeight = parseInt(window.getComputedStyle(elementRef.current).getPropertyValue('height'))+parseInt(window.getComputedStyle(elementRef.current).getPropertyValue('margin-top'))+parseInt(window.getComputedStyle(elementRef.current).getPropertyValue('margin-bottom'));
    console.log("window.innerHeight",window.innerHeight);
    let additional_spacing = window.innerHeight - myelementHeight - footerHeight; 
    if(includeHeader)
    {
        additional_spacing -= headerHeight;
    }

    if(spacerElementRef.current)
    {
        if(additional_spacing < 0)
        {
            additional_spacing = 0;
        }
        spacerElementRef.current.style.height = `${additional_spacing}px`;
    }
}

export const clearSpacer = (spacerElementRef:any) =>{
    if(spacerElementRef.current){
        spacerElementRef.current.style.height = `0px`;
    }
}

